import { render, staticRenderFns } from "./arrow_corner-12.vue?vue&type=template&id=0b3ce216&scoped=true"
import script from "./arrow_corner-12.vue?vue&type=script&lang=js"
export * from "./arrow_corner-12.vue?vue&type=script&lang=js"
import style0 from "./arrow_corner-12.vue?vue&type=style&index=0&id=0b3ce216&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ce216",
  null
  
)

export default component.exports